/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Autonomous_InterceptionInputs */

const en_autonomous_interception = /** @type {(inputs: Autonomous_InterceptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autonomous Interception`)
};

const es_autonomous_interception = /** @type {(inputs: Autonomous_InterceptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intercepción autónoma`)
};

const fr_autonomous_interception = /** @type {(inputs: Autonomous_InterceptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interception autonome`)
};

const de_autonomous_interception = /** @type {(inputs: Autonomous_InterceptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autonome Interception`)
};

const ja_autonomous_interception = /** @type {(inputs: Autonomous_InterceptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自律的な対応`)
};

const zh_autonomous_interception = /** @type {(inputs: Autonomous_InterceptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自主拦截响应`)
};

const ar_autonomous_interception = /** @type {(inputs: Autonomous_InterceptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الاعتراض المستقل`)
};

const id_autonomous_interception = /** @type {(inputs: Autonomous_InterceptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intersepsi Otonom`)
};

const it_autonomous_interception = /** @type {(inputs: Autonomous_InterceptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intercettazione Autonoma`)
};

const ru_autonomous_interception = /** @type {(inputs: Autonomous_InterceptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Автономный перехват`)
};

const pt_autonomous_interception = /** @type {(inputs: Autonomous_InterceptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interceptação Autônoma`)
};

const ko_autonomous_interception = /** @type {(inputs: Autonomous_InterceptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`자율적 대응`)
};

/**
* | output |
* | --- |
* | "Autonomous Interception" |
*
* @param {Autonomous_InterceptionInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const autonomous_interception = /** @type {((inputs?: Autonomous_InterceptionInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Autonomous_InterceptionInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_autonomous_interception(inputs)
	if (locale === "es") return es_autonomous_interception(inputs)
	if (locale === "fr") return fr_autonomous_interception(inputs)
	if (locale === "de") return de_autonomous_interception(inputs)
	if (locale === "ja") return ja_autonomous_interception(inputs)
	if (locale === "zh") return zh_autonomous_interception(inputs)
	if (locale === "ar") return ar_autonomous_interception(inputs)
	if (locale === "id") return id_autonomous_interception(inputs)
	if (locale === "it") return it_autonomous_interception(inputs)
	if (locale === "ru") return ru_autonomous_interception(inputs)
	if (locale === "pt") return pt_autonomous_interception(inputs)
	return ko_autonomous_interception(inputs)
});